import * as React from 'react';
import * as _ from 'lodash';
import { connect, Dispatch } from "react-redux";
import { IApplicationState, AppActionCreators, VoucherSimulationActionCreators, IVoucherSimulationSummaryResponse } from "@nkr/store/index";
import { IVoucherSimulationConfigSummary, IVoucherSimulationSummary } from '@nkr/models/voucher-simulation';
import { FormControl, Glyphicon, Panel, Table } from 'react-bootstrap';
import styled from 'styled-components';
import RunList from './list';
import Configuration from './configuration';
import { downloadFile } from '@nkr/services/download-file';
import { TableWrapper } from './styles';

const Styles = styled.div`
    .table > thead > tr > th,
    .table > tbody > tr > td {
        text-align: center;
    }
`;

interface IResultWithExpand extends IVoucherSimulationSummary {
    isExpanded: boolean
}

interface IOwnProps {
    fileId: string
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getSimulationSummary: (fileId: string, percentile: number) => Promise<IVoucherSimulationSummaryResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    percentile: number,
    list: IResultWithExpand[],
    config: IVoucherSimulationConfigSummary,
    configExpanded: boolean
}

class VoucherSimulationResults extends React.Component<TProps, IState> {
    readonly state: IState = {
        percentile: 90,
        list: [],
        config: null,
        configExpanded: false
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting summary, one moment please...').then(() => {
            this.props.getSimulationSummary(this.props.fileId, this.state.percentile).then(response => {
                if (response.data.success) {
                    let { summary, config } = response.data.results;

                    let list = summary.map(x => ({ ...x, isExpanded: false }));

                    this.setState({
                        list,
                        config
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    handlePercentileChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            percentile: parseInt(e.currentTarget.value)
        }, () => {
            this.getData();
        });
    }

    handleExpand = (year: number) => {
        let list = _.cloneDeep(this.state.list).map(x => {
            if (x.year == year) {
                x.isExpanded = !x.isExpanded;
            }

            return x;
        });

        this.setState({
            list
        });
    }

    render = () => {
        const percentiles = _.range(0, 110, 10);
        const configName = this.state.config != null ? this.state.config.name : '';
        const configOutput = this.state.config != null ? this.state.config.output : [];

        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <div style={{ fontSize: 28, fontWeight: 500 }}>VOUCHER SIMULATION RESULTS [{configName}]</div>
                    <div style={{ textAlign: 'center' }}>
                        <a href={__API__ + '/voucher/simulation/' + this.props.fileId + '/all-coverage.csv'}>Download All Coverages</a>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                        <div>Percentile:&nbsp;</div>
                        <FormControl
                            componentClass='select'
                            value={this.state.percentile}
                            onChange={this.handlePercentileChange}
                        >
                            {percentiles.map(percentile =>
                                <option value={percentile}>{percentile}</option>
                            )}
                        </FormControl>
                    </div>
                </div>

                <Panel expanded={this.state.configExpanded} onToggle={() => this.setState({ configExpanded: !this.state.configExpanded })}>
                    <Panel.Heading>
                        <Panel.Title toggle>Configuration Information</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible>
                        {this.state.configExpanded && (
                            <Configuration list={configOutput} />
                        )}
                    </Panel.Body>
                </Panel>

                {/* <Styles> */}
                    <TableWrapper bordered condensed>
                        <thead>
                            <tr className='top'>
                                <th colSpan={2}></th>
                                <th colSpan={2}>Min</th>
                                <th colSpan={2}>25th %</th>
                                <th colSpan={2}>50th %</th>
                                <th colSpan={2}>75th %</th>
                                <th colSpan={2}>Max %</th>
                                <th colSpan={3}></th>
                            </tr>
                            <tr className='bottom'>
                                <th style={{ width: 50 }}></th>
                                <th style={{ width: 50 }}>Year</th>

                                <th>CR</th>
                                <th>'O' CR</th>

                                <th>CR</th>
                                <th>'O' CR</th>

                                <th>CR</th>
                                <th>'O' CR</th>

                                <th>CR</th>
                                <th>'O' CR</th>

                                <th>CR</th>
                                <th>'O' CR</th>

                                <th>Sim #</th>

                                <th>Selected CR</th>
                                <th>Selected 'O' CR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.list.map(item =>
                                <>
                                    <tr style={{ backgroundColor: item.year % 2 == 1 ? '#fff' : '#f9f9f9' }}>
                                        <td><div onClick={() => this.handleExpand(item.year)}><Glyphicon glyph={item.isExpanded ? 'chevron-down' : 'chevron-right'} /></div></td>
                                        <td>{item.year}</td>
                                        <td>{item.coverageMin}</td>
                                        <td>{item.coverageOMin}</td>

                                        <td>{item.coverage25}</td>
                                        <td>{item.coverageO25}</td>

                                        <td>{item.coverage50}</td>
                                        <td>{item.coverageO50}</td>

                                        <td>{item.coverage75}</td>
                                        <td>{item.coverageO75}</td>

                                        <td>{item.coverageMax}</td>
                                        <td>{item.coverageOMax}</td>

                                        <td>{item.selectedSimNumber}</td>
                                        <td>{item.selectedCoverage}</td>
                                        <td>{item.selectedCoverageO}</td>
                                    </tr>

                                    {item.isExpanded && (
                                        <tr>
                                            <td colSpan={15} className='bg-info' style={{ padding: 16 }}>
                                                <RunList fileId={this.props.fileId} list={item.sortedRunsList} />
                                            </td>
                                        </tr>
                                    )}
                                </>
                            )}
                        </tbody>
                    </TableWrapper>
                {/* </Styles> */}
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSimulationSummary: (fileId, percentile) => {
            return dispatch(VoucherSimulationActionCreators.getSimulationSummary(fileId, percentile));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(VoucherSimulationResults)